module.exports = __webpack_public_path__ + "static/media/import_icon.96e9cb2e.svg";